import FullImgSnap from './slideTypes/FullImgSnap';
import HorizontalPan from './slideTypes/HorizontalPan';
import TwoColumnReveal from './slideTypes/TwoColumnReveal';
import VerticalPan from './slideTypes/VerticalPan';

const slideTypes = {
  FullImgSnap,
  HorizontalPan,
  TwoColumnReveal,
  VerticalPan
};

export default slideTypes;



// WEBPACK FOOTER //
// ../core/src/components/Slideshow/slideTypes.js